module.exports = __webpack_public_path__ + "img/phone-icon.9080b598.svg";